if (!customElements.get("product-card")) {
  customElements.define(
    "product-card",
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.media = this.querySelector(".media.media--hover-effect");
        this.colorSwatches = this.querySelectorAll(
          ".card__color-swatch--button"
        );
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.addEventListener("mouseenter", this.onHover.bind(this));
        this.addEventListener("mouseleave", this.onLeave.bind(this));
        this.querySelectorAll(".card__add label").forEach((e) =>
          e.addEventListener("click", this.addToCart.bind(this))
        );
        this.colorSwatches.forEach((e) => {
          e.addEventListener("click", this.onchangeColor.bind(this));
        });
      }

      onHover() {
        if (this.media.querySelector("video")) {
          this.media.querySelector("video").play();
        }
      }

      onLeave() {
        if (this.media.querySelector("video")) {
          this.media.querySelector("video").pause();
          this.media.querySelector("video").currentTime = 0;
        }
      }

      onchangeColor(e) {
        this.querySelector(
          ".card__color-swatch--button.active"
        ).classList.remove("active");
        e.currentTarget.classList.add("active");
        this.querySelectorAll("[data-target-handle].active").forEach((i) => {
          i.classList.remove("active");
        });
        this.querySelectorAll(
          `[data-target-handle="${e.currentTarget.dataset.handle}"]`
        ).forEach((i) => {
          i.classList.add("active");
        });
      }

      addToCart(e) {
        let currentTarget = e.currentTarget;
        currentTarget.querySelector("span").classList.add("hidden");
        currentTarget
          .querySelector(".loading__spinner")
          .classList.remove("hidden");

        let targetInput = currentTarget.parentElement.querySelector("input");
        let selectedOption = [
          ...this.querySelectorAll(
            ".card__option-list:not(.card__add) input:checked, .card__color-swatch input:checked"
          ),
          targetInput,
        ].map((e) => e.value);

        let selectedVariant = JSON.parse(
          this.querySelector(
            `script[data-handle="${
              currentTarget.closest(".card__quick-add-wrapper").dataset
                .targetHandle
            }"]`
          ).textContent
        ).variants.find((e) =>
          _.isEqual(e.options.sort(), selectedOption.sort())
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        formData.append("id", selectedVariant.id);
        formData.append("sections", "cart-drawer,cart-icon-bubble");
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            document.querySelector("#cart-icon-bubble").innerHTML =
              response.sections["cart-icon-bubble"];
            this.cart.renderContents(response);
            let nextCount =
              parseInt(
                currentTarget.closest(".card").querySelector(".card__count")
                  .dataset.count
              ) + 1;
            currentTarget
              .closest(".card")
              .querySelector(".card__count").innerHTML = nextCount;
            currentTarget
              .closest(".card")
              .querySelector(".card__count").dataset.count = nextCount;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            currentTarget.querySelector("span").classList.remove("hidden");
            currentTarget
              .querySelector(".loading__spinner")
              .classList.add("hidden");
          });
      }
    }
  );
}
